import { Subscription } from "../../models/RestModels";

export function getEmptySubscription(): Subscription
{
		let date = new Date();
		return {
			asset_code: null,
			assigned_by_user_id: null,
			balance_qty: null,
			created: date,
			created_by_user_id: 0,
			duration_qty: null,
			duration_unit: null,
			expiration_anchor: 'EXACT_PERIOD',
			expires_at: null,
			id: 0,
			is_returnable: 0,
			item_id: null,
			last_order_id: null,
			last_payment_id: null,
			note: null,
			parent_subscription_id: null,
			returned_at: null,
			scheduled_delivery: null,
			scheduled_return: null,
			serial_id: null,
			starts_at: '',
			status: 'ACTIVE',
			store_id: null,
			total_qty: null,
			updated: date,
			updated_by_user_id: 0,
			user_id: 0,
		};
}
